import { BaseAPI } from './base';
import type { BaseResponse, ListResponse, PaginationRequest } from '../../types/base.dto';
import apiClient from '../apiClient';
import { Shop } from '../../types/entity/shop';

// 店铺列表查询参数
export interface ShopListParams extends PaginationRequest {
  name?: string;
  code?: string;
  main_body_id?: string;
  status?: number;
  platform?: string;
}

// 店铺创建参数
export interface ShopCreateParams {
  name: string;
  code?: string;
  main_body_id?: string;
  status?: number;
  platform?: string;
  description?: string;
}

// 店铺更新参数
export interface ShopUpdateParams {
  name?: string;
  code?: string;
  main_body_id?: string;
  status?: number;
  platform?: string;
  description?: string;
}

/**
 * 店铺API服务类
 * 继承BaseAPI，提供店铺相关的CRUD操作
 */
export class ShopAPI extends BaseAPI<Shop> {
  constructor() {
    super('/shops');
  }

  /**
   * 根据主体ID获取店铺列表
   * @param mainBodyId 主体ID
   * @returns Promise<BaseResponse<Shop[]>>
   */
  async getShopsByMainBodyId(mainBodyId: string): Promise<BaseResponse<Shop[]>> {
    const response = await apiClient.get(`/shops/main-body/${mainBodyId}`);
    return response.data;
  }
}

// 创建店铺API实例
export const shopApi = new ShopAPI();

export default shopApi;